import { render, staticRenderFns } from "./UsageReadOnly.vue?vue&type=template&id=80d64208"
import script from "./UsageReadOnly.vue?vue&type=script&lang=js"
export * from "./UsageReadOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports